import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function TermsPage() {
  useMetaTags({
    title: 'Terms & Conditions | FindOnlineDegrees',
    description: 'Review the terms and conditions that govern your use of FindOnlineDegrees, including site content, services, and responsibilities.'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-1801" data-mp="2f67ra77nhtfx">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-1802" data-mp="2t6iduy1xglva">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1803" data-mp="2t4nuho6b11tb">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1804" data-mp="2o75vapi3a0yi">
            Terms & Conditions
          </h1>
          <p className="text-gray-300 text-sm" data-id="element-1805" data-mp="32waea8wpk97o">Last updated: May 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1806" data-mp="2y037yf0egvp7">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-1807" data-mp="3bybad2g7gp7r">
          {/* Agreement to Terms */}
          <div data-id="element-1808" data-mp="37xrb9tc2nbiz">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1809" data-mp="37u3gyrysyl37">
              AGREEMENT TO TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1810" data-mp="2zoja1uqipivp">
              <p data-id="element-1811" data-mp="2zqvpa04w5f52">
                These Terms of Use constitute a legally binding agreement
                between you and FindOnlineDegrees.org concerning your access to
                and use of the website. By accessing the site, you confirm that
                you have read, understood, and agree to be bound by these Terms
                of Use.{' '}
                <strong data-id="element-1812" data-mp="3imlurxc18tnp">
                  IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, YOU ARE
                  PROHIBITED FROM USING THE SITE AND MUST DISCONTINUE USE
                  IMMEDIATELY.
                </strong>
              </p>
              <p data-id="element-1813" data-mp="3sfb1kewn1jcp">
                We reserve the right to make changes or modifications to these
                Terms of Use at any time and for any reason. We will alert you
                to any changes by updating the "Last updated" date above. Your
                continued use of the site after revised terms are posted
                constitutes acceptance of the changes.
              </p>
              <p data-id="element-1814" data-mp="37ml0obkc02we">
                The site is intended for users who are at least{' '}
                <strong data-id="element-1815" data-mp="3mfemsfu3zha1">18 years</strong> old. Persons under 18 are not
                permitted to use or register for the site.
              </p>
            </div>
          </div>

          {/* Intellectual Property Rights */}
          <div data-id="element-1816" data-mp="3qf5lr6tsh3pn">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1817" data-mp="3qfot5tltc9pf">
              INTELLECTUAL PROPERTY RIGHTS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1818" data-mp="969zfzuytp12">
              <p data-id="element-1819" data-mp="47fjr6saogl6">
                Unless otherwise indicated, the site is our proprietary
                property, and all source code, databases, functionality,
                software, website designs, audio, video, text, photographs, and
                graphics on the site are owned or controlled by us or licensed
                to us, and are protected by copyright and trademark laws.
              </p>
              <p data-id="element-1820" data-mp="qet0x8ybf6e8">
                The content is provided <strong data-id="element-1821" data-mp="qhxbco2diydc">"AS IS"</strong> for your
                information and personal use only. Except as expressly provided
                in these Terms of Use, no part of the site or content may be
                copied, reproduced, aggregated, republished, uploaded, posted,
                publicly displayed, encoded, translated, transmitted,
                distributed, sold, licensed, or otherwise exploited for any
                commercial purpose without our express prior written permission.
              </p>
              <p data-id="element-1822" data-mp="3twb9jilwwhfp">
                You are granted a limited license to access and use the site and
                to download or print a copy of any portion of the content to
                which you have properly gained access solely for your{' '}
                <strong data-id="element-1823" data-mp="1s4onlvgvncq3">personal, non-commercial use</strong>.
              </p>
            </div>
          </div>

          {/* User Representations */}
          <div data-id="element-1824" data-mp="3j8zy18phrjv7">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1825" data-mp="3jakwvaiu9oyv">
              USER REPRESENTATIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1826" data-mp="3f6d7db4k44zl">
              <p data-id="element-1827" data-mp="3a7s2uzi9uz5c">By using the site, you represent and warrant that:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1828" data-mp="359gtsqzswso6">
                <li data-id="element-1829" data-mp="35b1nyfi7e9li">
                  All registration information you submit will be true,
                  accurate, current, and complete
                </li>
                <li data-id="element-1830" data-mp="2vj5r17ruspiv">
                  You will maintain the accuracy of such information and
                  promptly update it as necessary
                </li>
                <li data-id="element-1831" data-mp="2mj96nichyctm">
                  You have the legal capacity and agree to comply with these
                  Terms of Use
                </li>
                <li data-id="element-1832" data-mp="2hlh4lvi51abp">
                  You are not a minor in the jurisdiction in which you reside
                </li>
                <li data-id="element-1833" data-mp="x1vig5b0ugjy">
                  You will not access the site through automated or non-human
                  means
                </li>
                <li data-id="element-1834" data-mp="170ksjbwoewpn">
                  You will not use the site for any illegal or unauthorized
                  purpose
                </li>
                <li data-id="element-1835" data-mp="1b1cztzlzmrja">
                  Your use of the site will not violate any applicable law or
                  regulation
                </li>
              </ul>
            </div>
          </div>

          {/* Prohibited Activities */}
          <div data-id="element-1836" data-mp="ncbzz0r80opm">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1837" data-mp="nbsg3ei0fq8y">
              PROHIBITED ACTIVITIES
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1838" data-mp="s42bvb5t3kj5">
              <p data-id="element-1839" data-mp="3rqs5ys7il8tf">
                You may not access or use the site for any purpose other than
                that for which we make the site available. The site may not be
                used in connection with any commercial endeavors except those
                that are specifically endorsed or approved by us.
              </p>
              <p data-id="element-1840" data-mp="xxr9mhnm4rzx">As a user of the site, you agree not to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1841" data-mp="1cn6vpkc7899a">
                <li data-id="element-1842" data-mp="1cmnbty2znasm">
                  Systematically retrieve data or other content from the site to
                  create a collection, compilation, database, or directory
                </li>
                <li data-id="element-1843" data-mp="jz1c50wvsqb1">
                  Make any unauthorized use of the site, including collecting
                  usernames and/or email addresses by electronic or other means
                </li>
                <li data-id="element-1844" data-mp="t0sh23jlkt3u">
                  Use the site to advertise or offer to sell goods and services
                </li>
                <li data-id="element-1845" data-mp="p08hyufgrff2">
                  Circumvent, disable, or otherwise interfere with
                  security-related features of the site
                </li>
                <li data-id="element-1846" data-mp="20choofnb4zcv">
                  Engage in unauthorized framing of or linking to the site
                </li>
                <li data-id="element-1847" data-mp="27ymxk1nb7ush">Trick, defraud, or mislead us and other users</li>
                <li data-id="element-1848" data-mp="2cweootg4rcvm">
                  Interfere with, disrupt, or create an undue burden on the site
                  or the networks or services connected to the site
                </li>
                <li data-id="element-1849" data-mp="22yid60ja6fwz">Attempt to impersonate another user or person</li>
                <li data-id="element-1850" data-mp="2qnbfqfuerm0k">
                  Use any information obtained from the site to harass, abuse,
                  or harm another person
                </li>
                <li data-id="element-1851" data-mp="2vlczz43klrdm">
                  Use the site in a manner inconsistent with any applicable laws
                  or regulations
                </li>
              </ul>
            </div>
          </div>

          {/* User Generated Contributions */}
          <div data-id="element-1852" data-mp="39lnnpy9l2puk">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1853" data-mp="39l45egg0tzg0">
              USER GENERATED CONTRIBUTIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1854" data-mp="3eep7ajkqjdkh">
              <p data-id="element-1855" data-mp="1eb67sv50jb6i">
                The site may invite you to chat, contribute to, or participate
                in blogs, message boards, online forums, and other
                functionality. Any content you transmit to the site will be
                treated as non-confidential and non-proprietary.
              </p>
              <p data-id="element-1856" data-mp="10ksyopgdxqfl">
                By posting content to the site, you grant us an unrestricted,
                unlimited, irrevocable, perpetual, non-exclusive, transferable,
                fully-paid, worldwide right to use, copy, reproduce, distribute,
                and display such content.
              </p>
            </div>
          </div>

          {/* Submissions */}
          <div data-id="element-1857" data-mp="1j8o6lspbga0s">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1858" data-mp="1j97qheyj18hg">
              SUBMISSIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1859" data-mp="crat3ayg3jho">
              <p data-id="element-1860" data-mp="7tiyg96f1j9s">
                You acknowledge and agree that any questions, comments,
                suggestions, ideas, feedback, or other information regarding the
                site provided by you to us are non-confidential and shall become
                our sole property. We shall own exclusive rights, including all
                intellectual property rights, and shall be entitled to the
                unrestricted use and dissemination of these submissions for any
                lawful purpose, commercial or otherwise, without acknowledgment
                or compensation to you.
              </p>
            </div>
          </div>

          {/* Site Management */}
          <div data-id="element-1861" data-mp="qgclk3uainfh">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1862" data-mp="qft1ohl2xoyt">
              SITE MANAGEMENT
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1863" data-mp="vc1li8a826cb">
              <p data-id="element-1864" data-mp="2s7pl0ddho345">We reserve the right, but not the obligation, to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1865" data-mp="2x4zcdykfuoum">
                <li data-id="element-1866" data-mp="2x7lidtrokwaq">Monitor the site for violations of these Terms of Use</li>
                <li data-id="element-1867" data-mp="pg1x3i0t1rjg">
                  Take appropriate legal action against anyone who violates the
                  law or these Terms of Use
                </li>
                <li data-id="element-1868" data-mp="yevzxq4qbe5g">
                  Refuse, restrict access to, limit availability of, or disable
                  any of your contributions
                </li>
                <li data-id="element-1869" data-mp="18dcusy6sgcws">
                  Remove from the site or otherwise disable all files and
                  content that are excessive in size or burdensome to our
                  systems
                </li>
                <li data-id="element-1870" data-mp="1i3ellxqj09fe">
                  Manage the site in a manner designed to protect our rights and
                  property and to facilitate the proper functioning of the site
                </li>
              </ul>
            </div>
          </div>

          {/* Privacy Policy */}
          <div data-id="element-1871" data-mp="1w2xg3nqezm98">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1872" data-mp="1w2e74wiqs87c">
              PRIVACY POLICY
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1873" data-mp="2674bf91mboeq">
              <p data-id="element-1874" data-mp="21817xt1adq8v">
                We care about data privacy and security. Please review our
                Privacy Policy. By using the site, you agree to be bound by our
                Privacy Policy, which is incorporated into these Terms of Use.
              </p>
            </div>
          </div>

          {/* SMS Communications Terms */}
          <div data-id="element-1875" data-mp="2ow0zuwac3mp1">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1876" data-mp="2owkf258lnwzd">
              SMS COMMUNICATIONS TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1877" data-mp="2f7j1smtfvtp3">
              <p data-id="element-1878" data-mp="2f5ptz473b3fi">
                By providing your mobile phone number and submitting a form on
                our site, you agree to the following terms governing SMS/text
                message communications:
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1879" data-mp="32x50za9ta8x3">Program Description</h3>
              <p data-id="element-1880" data-mp="32v0nq1q0vxk5">
                FindOnlineDegrees.org may send you autodialed and/or
                pre-recorded marketing text messages (SMS/MMS) regarding
                educational programs, follow-up inquiries, and promotional
                offers from us and our educational partners.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1881" data-mp="w8uvtqwmz55g">Consent</h3>
              <p data-id="element-1882" data-mp="w7a1o2e8ho84">
                By submitting your information, you expressly consent to receive
                such messages at the mobile number provided. Consent is not a
                condition of any purchase or service. Your consent is governed
                by our Privacy Policy, which is incorporated herein by
                reference.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1883" data-mp="db1s4me6ur70">Message Frequency</h3>
              <p data-id="element-1884" data-mp="22p6nd94ydos2">
                Message frequency varies. You may receive multiple messages per
                inquiry depending on your interactions and program interests.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1885" data-mp="3s5spq32mv1on">Costs</h3>
              <p data-id="element-1886" data-mp="3s6bwcnmu23nd">
                Message and data rates may apply. Contact your wireless carrier
                for details about your plan.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1887" data-mp="5rj3o0m6e5r1">Opt-Out</h3>
              <p data-id="element-1888" data-mp="zrbjlndfrys">
                You may opt out of SMS communications at any time by replying
                STOP to any message received. After opting out, you will receive
                a single confirmation message and no further SMS marketing
                messages will be sent unless you provide new consent.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1889" data-mp="ooafxq3avkll">Assistance</h3>
              <p data-id="element-1890" data-mp="jqihsec2b28y">
                For help, reply HELP to any message or contact us through the
                information provided on our website.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1891" data-mp="2qit2587nnq2t">
                No Warranty for Delivery
              </h3>
              <p data-id="element-1892" data-mp="2mysvvag2x1lz">
                We do not guarantee that SMS messages will be delivered.
                Delivery is subject to effective transmission and your carrier's
                coverage and policies. We are not liable for delays or failures
                in SMS delivery.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1893" data-mp="31w1o06d7i9er">Third-Party Carriers</h3>
              <p data-id="element-1894" data-mp="31tz0pu3fuudq">
                You acknowledge that SMS transmission involves third-party
                carriers over whom we have no control. Standard carrier terms
                and conditions apply.
              </p>
            </div>
          </div>

          {/* Email Communications Terms */}
          <div data-id="element-1895" data-mp="2e4mjc6xyjg0c">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1896" data-mp="2ix7dj9krzv4e">
              EMAIL COMMUNICATIONS TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1897" data-mp="1lilbgrms60cx">
              <h3 className="font-bold text-lg" data-id="element-1898" data-mp="1qgwiyvplryrz">Program Description</h3>
              <p data-id="element-1899" data-mp="1qes7nspdjxho">
                FindOnlineDegrees.org may send you marketing and promotional
                emails regarding educational programs, follow-up inquiries, and
                offers from us and our educational partners. Marketing emails
                are sent from contact@findonlinedegrees.org on behalf of Media
                Matchers LLC.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1900" data-mp="3pqvc737hp78f">Consent</h3>
              <p data-id="element-1901" data-mp="3kstqsbmlcvts">
                By submitting your information on our site, you expressly
                consent to receive such emails at the address provided. Consent
                is not a condition of any purchase or service.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1902" data-mp="3bxvzta307t53">Opt-Out</h3>
              <p data-id="element-1903" data-mp="3726v6sc4nm1x">
                You may opt out of marketing emails at any time by clicking the
                unsubscribe link included in every marketing email. Opt-out
                requests will be honored within 10 business days. You may also
                opt out by contacting us at the address below.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1904" data-mp="2nh6okniytch0">CAN-SPAM Compliance</h3>
              <p data-id="element-1905" data-mp="2sfrnmjmhdq3v">
                All commercial emails we send will accurately identify the
                sender, include our physical mailing address, and include a
                working unsubscribe mechanism.
              </p>
            </div>
          </div>

          {/* Term and Termination */}
          <div data-id="element-1906" data-mp="366da0ib58i6i">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1907" data-mp="367ob2ad7fbtx">
              TERM AND TERMINATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1908" data-mp="2xdjfxer1fe8l">
              <p data-id="element-1909" data-mp="2xb71hbkhnm0a">
                These Terms of Use shall remain in full force and effect while
                you use the site. We reserve the right to deny access to the
                site to anyone for any reason at any time without notice.
              </p>
              <p data-id="element-1910" data-mp="3tw7iknofjkky">
                If we terminate or suspend your access for any reason, you are
                prohibited from registering and creating a new account under
                your name or a borrowed name. We reserve the right to take
                appropriate legal action, including civil, criminal, and
                injunctive redress.
              </p>
            </div>
          </div>

          {/* Disclaimer */}
          <div data-id="element-1911" data-mp="1n9053egeinaa">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1912" data-mp="zhcq9uwez2od">
              DISCLAIMER
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1913" data-mp="uihvdul69nnw">
              <p data-id="element-1914" data-mp="ukcer4gsp7pv">
                THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
                AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR
                SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM
                ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE
                AND YOUR USE THEREOF.
              </p>
              <p data-id="element-1915" data-mp="2fxp0qxyou0en">
                WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
                COMPLETENESS OF THE SITE'S CONTENT OR THE CONTENT OF ANY
                WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR
                RESPONSIBILITY FOR ANY ERRORS, MISTAKES, OR INACCURACIES OF
                CONTENT AND MATERIALS.
              </p>
            </div>
          </div>

          {/* Limitations of Liability */}
          <div data-id="element-1916" data-mp="wvv4wklfm5y8">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1917" data-mp="ww4zklhf91a9">
              LIMITATIONS OF LIABILITY
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1918" data-mp="110l1ycrttqkq">
              <p data-id="element-1919" data-mp="15yw9ggunfozs">
                IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
                LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
                CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
                DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
                OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE.
              </p>
            </div>
          </div>

          {/* Indemnification */}
          <div data-id="element-1920" data-mp="30djlj53v7ov6">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1921" data-mp="30crywjs8x1h1">
              INDEMNIFICATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1922" data-mp="2vf8a4pxx96au">
              <p data-id="element-1923" data-mp="2qgeyz463xrdu">
                You agree to defend, indemnify, and hold us harmless, including
                our subsidiaries, affiliates, and all of our respective
                officers, agents, partners, and employees, from and against any
                loss, damage, liability, claim, or demand, including reasonable
                attorneys' fees and expenses, made by any third party due to or
                arising out of your use of the site or breach of these Terms of
                Use.
              </p>
            </div>
          </div>

          {/* Governing Law */}
          <div data-id="element-1924" data-mp="1xqos9g6t1rrr">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1925" data-mp="1xq6ntw9zo78r">
              GOVERNING LAW
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1926" data-mp="xl215f3nie4j">
              <p data-id="element-1927" data-mp="ssh9aj4b2b3n">
                These Terms of Use and your use of the site are governed by and
                construed in accordance with the laws of the State of
                California, without regard to its conflict of law principles.
                Except for disputes subject to binding arbitration under the
                Dispute Resolution / Arbitration section below, you agree that
                any dispute arising out of or relating to these Terms shall be
                resolved exclusively in the state or federal courts located in
                Los Angeles County, California.
              </p>
            </div>
          </div>

          {/* Dispute Resolution / Arbitration */}
          <div data-id="element-1928" data-mp="3rbfsgie3ns80">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1929" data-mp="3rbxyg6qkdkt4">
              DISPUTE RESOLUTION / ARBITRATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1930" data-mp="3nb5n97y4t5u7">
              <p data-id="element-1931" data-mp="22slgfyf2dkpz">
                Any dispute, claim, or controversy arising out of or relating to
                these Terms or your use of the site, including any claims under
                the Telephone Consumer Protection Act (TCPA), shall be resolved
                by binding individual arbitration under the rules of the
                American Arbitration Association. You waive any right to bring
                or participate in a class action lawsuit or class-wide
                arbitration. This arbitration agreement does not apply to claims
                that may be brought in small claims court.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-1932" data-mp="2zg887j170ex3">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1933" data-mp="2zene1uisixzr">
              CONTACT US
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1934" data-mp="15309vhe0dl6p">
              <p data-id="element-1935" data-mp="1538l74uhgifs">
                If you have any questions or concerns about these Terms &
                Conditions, please contact us at:
              </p>
              <p className="font-semibold" data-id="element-1936" data-mp="23fkyzccfieqs">Media Matchers LLC</p>
              <p data-id="element-1937" data-mp="2hekm2fkamlku">
                1865 Chestnut Street
                <br data-id="element-1938" data-mp="2hfdnr24eakw4" />
                San Francisco, CA 94123
              </p>
              <p data-id="element-1939" data-mp="2cf7xnqdrx6g5">
                Email:{' '}
                <a href="mailto:contact@findonlinedegrees.org" className="text-[#3b82f6] underline hover:text-blue-800" data-id="element-1940" data-mp="2chluo4s0ksqc">
                  contact@findonlinedegrees.org
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}